import type { Profile } from '@/types';

export const profile: Profile = {
  fullName: 'Muhammad Sufyan Malik',
  shortName: 'Sufyan Malik',
  title: 'Software Engineer building scalable web and mobile products',
  location: 'Çankaya, Ankara, Türkiye',
  email: 'muhammadsufyanmalik93@gmail.com',
  // CV also lists malikmsufyan@gmail.com — kept as secondary if you want it shown later.
  phonePrimary: '+90 553 695 7549',
  phoneSecondary: '+92 315 315 1468',
  githubUrl: 'https://github.com/MuhammadSufyanMalik',
  websiteUrl: 'https://muhammadsufyanmalik.com',
  resumePath: '/Muhammad_Sufyan_Malik.pdf',
  heroIntro:
    'Results-driven software engineer with experience across .NET backends, Angular web apps, and Flutter/Android/iOS clients—focused on clean architecture, CQRS-style designs, and reliable delivery.',
  about: [
    'I am a committed, results-driven software engineer with a strong interest in leadership and continuous learning. I look for challenging work in growth-oriented teams where solid engineering and clear communication matter.',
    'My recent work centers on C# and .NET Core systems using layered architecture, repository patterns, CQRS, MediatR, messaging, SignalR, and Elasticsearch—alongside Angular frontends and mobile delivery with Flutter, Android, and SwiftUI.',
    'Based in Ankara, I bring experience from both web platform engineering and hands-on mobile product development, from analysis through testing, deployment, and ongoing support.',
  ],
  focusAreas: [
    'Backend and API development with C#, .NET Core, CQRS, and MediatR',
    'Full-stack web applications with Angular and related tooling',
    'Cross-platform mobile development with Flutter, Android, and SwiftUI',
    'Search, messaging, and realtime integration (Elasticsearch, RabbitMQ, SignalR)',
  ],
};
